import dynamic from 'next/dynamic';
const SearchModal = dynamic(() => import('./SearchModal'));

export default SearchModal;
